<div class="section" [webSingleHover]="{ threshold: 20, type: 'percent' }" (hovered)="hovered($event)">
    <div
        class="section-container"
        [id]="entity().id"
        [attr.data-raw-id]="entity().id"
        [style.--section-column-gap-half]="columnGapHalf()"
        [class.has-flexible-columns]="isFlexibleWidths()"
        cdkDropList
        [cdkDropListAutoScrollStep]="25"
        cdkDropListOrientation="horizontal"
        [cdkDropListData]="entity().children"
        [cdkDropListConnectedTo]="connectedTo()"
        [cdkDropListEnterPredicate]="canEnterColumn"
        (cdkDropListDropped)="dropColumn($event)"
    >
        @for (column of entity().children; let i = $index; track column.id) {
            @let nextColumn = entity().children[i + 1];

            <div
                class="column-container"
                [class]="getColumnClasses(column)"
                [style.--column-width]="getColumnWidth(column)"
            >
                <web-column
                    [index]="i"
                    [entity]="column"
                    [parentEntity]="entity()"
                    [blockId]="parentEntityId()"
                    [parentEntityIndex]="index()"
                    [disableColumnCopy]="columnsCountReachedMax()"
                    [isLastColumn]="isLastSection() && columnCount() === 1"
                />

                @if (columnCount() !== i + 1 && columnCount() < 5) {
                    <web-column-resize
                        [columnLeft]="column"
                        [columnRight]="nextColumn"
                        [isColumnWidthFlex]="isFlexibleWidths()"
                        (changeWidthToLeftEvent)="changeColumnWidthToLeft(column, nextColumn)"
                        (changeWidthToRightEvent)="changeColumnWidthToRight(column, nextColumn)"
                    />
                }
            </div>
        }
    </div>

    @if (hideControls() && !isSectionRestricted()) {
        @if (!hasSectionActiveColumn() && hoverState()?.topThreshold) {
            <web-add-buttons
                type="top"
                [tooltipText]="'control_add_section' | translate"
                (addEvent)="addSection($event)"
            />
        }

        @if (hoverState()?.bottomThreshold) {
            <web-add-buttons
                type="bottom"
                [tooltipText]="'control_add_section' | translate"
                (addEvent)="addSection($event)"
            />
        }

        @if (!columnsCountReachedMax() && !hasCatalogProductsWidget()) {
            @if (hoverState()?.leftThreshold) {
                <web-add-buttons
                    type="left"
                    [show]="true"
                    [tooltipText]="'control_add_column' | translate"
                    [isFullWidthBlock]="isParentBlockFullWidth()"
                    (addEvent)="addColumn($event)"
                />
            }

            @if (hoverState()?.rightThreshold) {
                <web-add-buttons
                    type="right"
                    [show]="true"
                    [tooltipText]="'control_add_column' | translate"
                    [isFullWidthBlock]="isParentBlockFullWidth()"
                    (addEvent)="addColumn($event)"
                />
            }
        }
    }
</div>
